<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="userpackage">业务订购</a></li>
            </ul>
        </div>
        <div id="usual1" class="usual"> 
            <div class="formbody">
                <div class="formtitle"><span>业务订购</span></div>
                <div class="lh33 ea2020 f16"><b>已订购的业务（订购业务每日会产生最低消费，如果不使用，可以退订。每月可退订1次）</b></div>
                <table class="tablelist">
                    <thead>
                        <tr>
                            <th>业务名称</th>
                            <th>最低消费/天</th>
                            <th>订购时间</th>
                            <th>操作 </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in orderList">
                            <template v-for="(item1, index1) in packageList">
                                <template v-if="item1.packageid == item.packageid">
                                    <td>
                                        {{item1.packagename}}
                                    </td>
                                    <td>
                                        {{item1.feeday}}
                                    </td>
                                </template>
                            </template>
                            <td>
                                <!-- {{item.expired.substring(0,19)}} -->
                                {{item.orderdate.substring(0,19)}}
                            </td>
                            <td>
                                <a href="javascript:;" @click="notorderpackage(index)">【退订】</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
                <div class="jian">&nbsp;</div>
                <div class="lh33 ea2020 f16"><b>已过期的业务</b></div>
                <table class="tablelist">
                    <thead>
                        <tr>
                            <th>业务名称</th>
                            <th>最低消费/天</th>
                            <th>到期时间</th>
                            <th>操作 </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in overDateList">
                            <template v-for="(item1, index1) in packageList">
                                <template v-if="item1.packageid == item.packageid">
                                    <td>
                                        {{item1.packagename}}
                                    </td>
                                    <td>
                                        {{item1.feeday}}
                                    </td>
                                </template>
                            </template>
                            <td>
                                {{item.expired.substring(0,19)}}
                            </td>
                            <td>
                                <a href="javasrcipt:;" @click="continueorderpackage(index)">【续订】</a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="jian">&nbsp;</div>
                <div class="lh33 ea2020 f16"><b>可订购的业务</b></div>
                <table class="tablelist">
                    <thead>
                        <tr>
                            <th>业务名称</th>
                            <th>最低消费/天</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in notorderList">
                            <td>
                                {{item.packagename}}
                            </td>
                            <td>
                                {{item.feeday}}
                            </td>
                            <td>
                                <a href="javascript:;" @click="orderpackage(index)">【订购】</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div> 
        </div> 
    </div>
</template>

<script>
import cookie from '@/components/cookie.vue'
export default {
    data() {
        return {
            orderList: [],
            notorderList: [],
            overDateList: [],
            packageList: [],
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.getUserPackage()
    },
    methods: {
        getUserPackage() {
            var that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/userpackage.json",
                data:data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.orderList = res.data.userOrderPackageList
                    that.notorderList = res.data.notOrderPackageList
                    that.overDateList = res.data.userOverDuePackageList
                    that.packageList = res.data.packageList
                }
                else
                {
                    alert(res.data.msg)
                    return false
                }
            })
        },
        //退订
        notorderpackage(index) {
            var that = this
            let param = {'upid': this.orderList[index].upid, 'account': '', 'productcode': this.orderList[index].productcode}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/notorderpackage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.getUserPackage()
                }
                else
                {
                    alert(res.data.msg)
                    return false
                }
            })
        },
        //续订
        continueorderpackage(index) {
            var that = this
            let param = {'upid': this.overDateList[index].upid, 'account': '', 'productcode': this.overDateList[index].productcode}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/continueorderpackage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.getUserPackage()
                }
                else
                {
                    alert(res.data.msg)
                    return false
                }
            })
        },
        //订购
        orderpackage(index) {
            var that = this
            let param = {'packageid': this.notorderList[index].packageid, 'account': '', 'productcode': this.notorderList[index].productcode}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/orderpackage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.getUserPackage()
                }
                else
                {
                    alert(res.data.msg)
                    return false
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/person/userpackage.vue